import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { Group, GroupsApi, Metadata, PagedGroupResponse } from "src/app/hickory-api";
import { AuthZAccessControl } from "../../../authentication/access-control";
import { AuthService } from "../../../authentication/auth.service";
import { AddGroupAuthorizationComponent } from "../../add-group-authorization/add-group-authorization.component";
import { AuthorizationViewModel, AuthZCollection } from '../shared-authz-models';

export class GroupAuthZCollection extends AuthZCollection<GroupsApi, Group, PagedGroupResponse> {

  override get can() { return AuthZAccessControl.canAccessAuthZType(this.auth, 'group'); }

  public override get addButton() {
    return {
      show: this.can,
      icon: 'group_add',
      localizationKey: 'Admins.Management.Authorization.AddGroupButton'
    };
  }

  constructor(
    auth: AuthService,
    service: GroupsApi,
    metadata: Metadata,
    dialog: MatDialog,
    actions: string[]
  ) {
    super(
      auth, actions, metadata, 'Groups', 'group',
      service, dialog, AddGroupAuthorizationComponent
    )
  }

  protected override getItemsFromSource(): Observable<PagedGroupResponse> {
    return this.service.getGroupsV4(this.tenantId, this.ids, undefined, 1, this.ids.length);  
  }

  protected override getItemFromTag(tag: string): AuthorizationViewModel {
    const authz = new AuthorizationViewModel();
    authz.id = this.getGroupIdFromPath(tag);
    return authz;
  }

  private getGroupIdFromPath(path: string): number {
    const groupIds = path.split('/').filter(str => str !== '').map(Number);
    return groupIds[groupIds.length - 1];
  }
}